import { ROLES } from '../../../constants/role';

class MurabahaApis {
  static readonly CREATE_INVESTOR = '/api/system-users/investor/';
  static readonly GET_INVESTORS = '/api/system-users/get-investor/';
  static readonly GET_INVESTOR_BY_ID = '/api/system-users/get-investor';
  static readonly MURABAHA_HOLDINGS = '/api/holdings/list-holdings/';
  static readonly TRANSFER_UNITS = '/api/trade/transfer-units/';
  static readonly TRANSFERS_LIST = '/api/trade/list-transfer-units/';
  static readonly UNITS_INQUIRY = '/api/trade/units-inquiry/';
  static readonly VERIFY_IBAN = '/api/wallet/iban/verify/';
  static readonly VERIFY_IBAN_PROXY = '/api/wallet/iban-verification/';
  static readonly PROPERTIES = '/api/trade/list-properties/';
  static readonly MARKET_BUY_ORDER = '/api/orders/create-market-buy-order/';
  static readonly ORDER_DETAILS = '/api/orders/list-orders/';
  static readonly ORDER_TRADE_TIMELINE = 'api/trade/list-buy-orders-trade/';

  static readonly MURABAHA_TRANSFER_UNITS_TASKS =
    '/api/trade/transfer-units/?murabaha_task=true';

  static CREATE_MARKET_SELL_ORDER_TASK = (task_id: number) =>
    `/api/orders/murabaha/tasks/${task_id}/market-sell-orders/`;

  static CREATE_WITHDRAWAL_TASK = (task_id: number) =>
    `/api/orders/murabaha/tasks/${task_id}/withdrawals/`;

  static readonly MURABAHA_TASKS = '/api/orders/murabaha/tasks/';

  static MURABAHA_INVESTOR_BANK_DETAILS = (investor_id: number) =>
    `/api/wallet/bank-account-details/${investor_id}`;

  static MURABAHA_PRICE_INQUIRY = (property_id: number, units: number) =>
    `/api/orders/murabaha/price-calculation/?property_id=${property_id}&units=${units}`;

  static readonly WALLET_BALANCE = '/api/wallet/wallet-balance/';
  static readonly MARKET_STATUS = '/api/trade/market-status/';
  static readonly MURABAHA_API_CLIENTS = '/api/system-users/api-client/';
  static readonly MURABAHA_USERS = `/api/system-users/list-users/?user_type=${ROLES.MURABAHA_REPRESENTATIVE}`;
}

export default MurabahaApis;
